import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';


import { Authentication } from '@appModels/core-auth/auth/auth';

import * as fromReducer from '@appStore/reducers';
import * as fromSelectors from '@appStore/selectors';
import { Login } from '@appStore/actions/core-auth/auth/auth.actions';
import { UserService } from '@appServices/core-auth/user/user.service';
import * as moment from 'moment';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

    // The risky obserable object might be used to show some msg in template
    risky$ = this.store.pipe(select(fromSelectors.isRisky));
    errMsg = null

    auth$: Observable<Authentication>;

    loading= false;

    sent = false;
  currentYear: number;
    constructor(
      private store: Store<fromReducer.auth.State>,
       private renderer: Renderer2,
       private userService: UserService) {}

    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'reset_screen');
    }
    ngOnInit() {
      this.currentYear = moment().year()
      this.renderer.addClass(document.body, 'reset_screen');
    }

    // The form is submitted with the corresponding model type `Authentication`
    onSubmit(usernameEmailTelephone) {
      this.loading = true;
      const path = window.location.href
      this.userService.resetPassword({
        frontEndURL: path.replace(window.location.pathname,'/auth/reset-password'),
        usernameEmailTelephone: usernameEmailTelephone
      }).subscribe(data => {
        // if( data === undefined) {
        //   this.errMsg =  "User doesn't exist"
        // } else {
          this.sent = true;
        // }
        this.loading = false;


      }, error => {
        this.loading = false;

      })
      // this.store.dispatch(new Login({usernameEmailMobile: usernameEmailMobile, password}));

    }
}
